const generalController = (function () {

  const getUrlPath = () => {
    return window.location.href.split('/');
  }

  // Find all url parameters
  const getSearchParameters = () => {
    const prmstr = window.location.search.substr(1);
    return (prmstr !== null && prmstr !== "") ? transformToAssocArray(prmstr) : {};
  }

  const transformToAssocArray = (prmstr) => {
    let params = {};
    const prmarr = prmstr.split("&");
    for (var i = 0; i < prmarr.length; i++) {
      var tmparr = prmarr[i].split("=");
      params[tmparr[0]] = tmparr[1];
    }
    return params;
  };

  return {
    // Detect current language
    detectLanguage: function () {
      const urlPathArr = getUrlPath();
      const params = getSearchParameters();

      if (urlPathArr.includes('fr')) {
        return 'fr';
      } else if (params.lang === 'fr') {
        return 'fr';
      } else {
        return 'en';
      }
    },
    // Return URL search params
    getURLSearchParams: function () {
      return getSearchParameters();
    },
    // Get the normal HTML meta tag value.
    getMetatagValue: function (name) {
      const meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) {
        return meta.content
      } else {
        console.log('Error: Meta tag not found in getMetatagValue in generalController')
        return null
      }
    },
    // Get media query in the current viewport.
    getMediaQuery: function() {
      const breakpoints = {
        xs: 0,
        sm: 480,
        md: 767,
        lg: 1025,
        xl: 1200
      };
  
      let keys = Object.keys(breakpoints);
      let currentBP = null;
  
      for (let i = keys.length - 1; i >= 0; i--) {
        if (window.matchMedia(`(min-width: ${breakpoints[ keys[i] ]}px)`).matches) {
          currentBP = keys[i];
          break;
        }
      }
  
      return currentBP;
    },
  };
})();

export default generalController